// eslint-disable-next-line
import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _wrap_native_super from "@swc/helpers/src/_wrap_native_super.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
export var isDevLocal = function() {
    return "production" === "development";
};
export var DxlError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(DxlError, Error1);
    var _super = _create_super(DxlError);
    function DxlError(message) {
        _class_call_check(this, DxlError);
        var _this;
        _this = _super.call(this, message);
        var messageSplit = message.split("|_|");
        if (messageSplit.length === 3) {
            var ref;
            ref = _sliced_to_array(messageSplit, 2), _this.code = ref[0], _this.description = ref[1], ref;
            _this.message = messageSplit[2].replace(/transactionid.*/gi, "");
            _this.status = _this.code;
        } else {
            _this.code = "unknown";
            _this.description = message;
            _this.message = "Ops, si \xe8 verificato un errore.";
        }
        return _this;
    }
    return DxlError;
}(_wrap_native_super(Error));
export var NextError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(NextError, Error1);
    var _super = _create_super(NextError);
    function NextError(response, request) {
        _class_call_check(this, NextError);
        var _this;
        _this = _super.call(this);
        _this.getMessage = function() {
            return _this.message;
        };
        _this.getError = function() {
            return _this.error;
        };
        var url = request.url;
        var status = response.status, statusText = response.statusText, headers = response.headers;
        _this.message = JSON.parse(JSON.stringify("{requestUrl: ".concat(url, ", responseStatus: ").concat(status, ", responseStatusText: ").concat(statusText, "}")));
        _this.error = {
            url: url,
            status: status,
            statusText: statusText,
            headers: headers
        };
        return _this;
    }
    return NextError;
}(_wrap_native_super(Error));
export var delay = function(time) {
    return new Promise(function(resolve) {
        setTimeout(resolve, time);
    });
};
export var errorMessages = {
    activation: {
        strong: {
            generic: {
                title: "Operazione non consentita",
                description: "Al momento non \xe8 possibile attivare l'offerta"
            },
            charge_wait: {
                title: "Non \xe8 possibile attivare la promozione",
                description: "Sono gia attive alcune promozioni in attesa di ricarica."
            },
            deactivations: {
                title: "Non \xe8 possibile attivare la promozione",
                description: "Sono gi\xe0 attive alcune promozioni che vanno disattivate. Le promozioni sono:"
            },
            activations: {
                title: "Operazione non consentita",
                description: "Al momento non \xe8 possibile attivare l'offerta, \xe8 indispensabile attivare le seguenti promozioni:"
            },
            errors: {
                title: "Informazione",
                check_act_prod_not_man: "Siamo spiacenti ma al momento non \xe8 possibile attivare Giga Vacanza.",
                prod_not_man: "Non \xe8 possibile attivare il prodotto. Ci scusiamo per il disagio.",
                req_alr_ins: "Hai gi\xe0 effettuato la richiesta di attivazione per questo prodotto.",
                read_only_cond: "Non \xe8 possibile proseguire con l'operazione da te richiesta. Ci scusiamo per il disagio",
                prerequirements: "Non \xe8 possibile proseguire con l&rsquo;operazione da te richiesta. Ci scusiamo per il disagio.",
                not_reg_incomp: "Il prodotto \xe8 incompatibile con la tua offerta.",
                age_check_fail: "Il prodotto non \xe8 compatibile con il tuo profilo. Ti invitiamo a visitare la sezione Scopri nuove offerte",
                prod_alr_act: "Il prodotto \xe8 gi\xe0 attivo sul numero che stai utilizzando.",
                non_comm_pre_req_prod: "Non \xe8 possibile proseguire con l'operazione da te richiesta. Ci scusiamo per il disagio.",
                change_reas_fail: "Non \xe8 possibile proseguire con l'operazione da te richiesta. Ci scusiamo per il disagio.",
                tariff_model_incompatibility: "Questo prodotto non \xe8 compatibile con la tua offerta. Ti invitiamo a visitare il Catalogo Offerte.",
                deactivation_in_progress: "Questo prodotto \xe8 in fase di disattivazione. Attendi l'avvenuta disattivazione e riprova pi\xf9 tardi.",
                prod_not_man_on_market_cluster: "Non \xe8 possibile proseguire con l'operazione da te richiesta. Ci scusiamo per il disagio.",
                prod_not_man_on_user_profile_cluster: "Non \xe8 possibile proseguire con l&rsquo;operazione da te richiesta. Ci scusiamo per il disagio.",
                prod_not_man_on_object_typology_cluster: "Non \xe8 possibile proseguire con l&rsquo;operazione da te richiesta. Ci scusiamo per il disagio.",
                prod_not_man_on_channel_cluster: "Non \xe8 possibile proseguire con l'operazione da te richiesta. Ci scusiamo per il disagio.",
                generic: "Il prodotto \xe8 incompatibile con la tua offerta. ",
                check_act_promo_xmas_already_act: "Siamo spiacenti, hai gi\xe0 richiesto l'attivazione di un Vodafone Pass in regalo."
            }
        },
        weak: {
            deactivations: {
                description: " La tua nuova offerta sostituir\xe0"
            },
            activations: {
                title: "Attenzione",
                description: "Confermando l'attivazione saranno attivati:"
            },
            charge_wait: {
                description: "Puoi attivare l’offerta anche se il tuo credito non \xe8 sufficiente, ricordati di ricaricare per poterla utilizzare."
            },
            errors: {
                title: "Errore",
                description: "Si \xe8 verificato un errore"
            }
        },
        not_credit: {
            title: "Attenzione",
            description: "Il tuo credito non \xe8 sufficiente per attivare l'opzione. Ricarica online in modo semplice e veloce"
        },
        activation_params: {
            title: "Attenzione",
            description: "Per procedere con l'attivazione inserire le informazioni:"
        },
        confirm_activation: {
            title: "Richiesta in attivazione",
            description: "Hai richiesto l'attivazione dell'offerta @prodName@"
        },
        success_activation: {
            title: "Offerta in attivazione",
            description: "La richiesta \xe8 andata a buon fine."
        },
        success_activation_mail_to_send: {
            description: "Attendi l'SMS di conferma entro 48 ore. Inserisci di seguito il tuo indirizzo e-mail per ricevere la conferma dell'attivazione:"
        },
        success_activation_mail_sent: {
            description: "Attendi l'SMS di conferma entro 48 ore. Riceverai un email all'indizzo @emailAddress@"
        },
        success_lineup_activation: {
            title: "Offerta in attivazione",
            description: "La richiesta \xe8 andata a buon fine. Riceverai un SMS di conferma."
        },
        success_lineup_booked: {
            title: "La prenotazione dell’offerta \xe8 andata a buon fine",
            description: "La nuova offerta sar\xe0 attiva il giorno: @renewalDate@ e se vuoi modificarla di nuovo potrai farlo entro il giorno: @allowedDate@."
        },
        success_activation_request_nba_informative: {
            description: "La tua richiesta \xe9 stata presa in carico."
        },
        error_activation: {
            title: "Attenzione",
            description: "Siamo spiacenti, si \xe8 verificato un errore"
        }
    },
    deactivation: {
        generic: {
            title: "Operazione non consentita",
            description: "Al momento non \xe8 possibile disattivare l'offerta"
        },
        engaged: {
            title: "Operazione non consentita",
            description: "Hai gi&agrave; prenotato la disattivazione dell&rsquo;opzione. <br\\/> L&rsquo;opzione sar&agrave; disattivata il @deactivationDate@"
        },
        errors: {
            error: {
                title: "Operazione non consentita",
                description: "Al momento non \xe8 possibile disattivare l'offerta."
            },
            check_act_prod_not_man: "Siamo spiacenti ma al momento non \xe8 possibile attivare Giga Vacanza.",
            prod_not_man: "-",
            req_alr_ins: "-",
            read_only_cond: " Per questo prodotto \xe8 gi\xe0 stata richiesta la disattivazione",
            tariff_model_incompatibility: "Non \xe8 possibile proseguire con l'operazione da te richiesta. Ci scusiamo per il disagio.",
            prod_not_man_on_market_cluster: "-",
            prod_not_man_on_user_profile_cluster: "-",
            prod_not_man_on_object_typology_cluster: "-",
            prod_not_man_on_channel_cluster: "Non \xe8 possibile disattivare il prodotto. Ci scusiamo per il disagio.",
            generic: "-",
            deac_alr_req: "-",
            prod_not_act: "-",
            charge_reas_fail: "Non \xe8 possibile proseguire con l'operazione da te richiesta. Ci scusiamo per il disagio.",
            check_manag_sticky_failure_no_desc: "<b>Non \xe8 possibile disattivare il prodotto.</b> <br/>Non \xe8 possibile proseguire con l'operazione da te richiesta. Per disattivare il prodotto \xe8 necessario disattivare la tariffa base associata. ",
            check_manag_sticky_failure: "<b>Non \xe8 possibile disattivare il prodotto.</b> <br/>Non \xe8 possibile proseguire con l'operazione da te richiesta. Per disattivare il prodotto \xe8 necessario disattivare: "
        },
        option: {
            immediate: {
                title: "Disattiva subito",
                description: "L'opzione sar\xe0 disattivata subito dal tuo numero"
            },
            renewal: {
                title: "Disattiva alla scadenza",
                description: "L'opzione rimarr\xe0 attiva sul tuo numero e sar\xe0 disattivata il giorno @deactivationDate@"
            },
            not_selected: {
                message: "L'accettazione \xe8 obbligatoria"
            }
        },
        success_deactivation_mail_to_send: {
            description: "Attendi l'SMS di conferma entro 48 ore. Inserisci di seguito il tuo indirizzo e-mail per ricevere la conferma della disattivazione:"
        },
        success_deactivation_mail_sent: {
            description: "Riceverai una e-mail di conferma all'indirizzo @emailAddress@"
        },
        success_deactivation: {
            title: "Offerta in disattivazione",
            description: "La richiesta \xe8 andata a buon fine."
        },
        success_booked_deactivation: {
            title: "Offerta in annullamento",
            description: "La richiesta \xe8 andata a buon fine."
        },
        confirm_deactivation: {
            title: "Attenzione",
            description: "Sei sicuro di voler disattivare @prodName@ ?"
        }
    },
    renewal: {
        checkBlockType: {
            title: "Attenzione",
            generic: "Operazione non consentita. Non \xe8 possibile far ripartire la tua opzione. Ci scusiamo per il disagio.",
            activated: "Operazione non consentita. Non \xe8 possibile far ripartire la tua opzione. Ci scusiamo per il disagio.",
            engaged: "Hai gi\xe0 richiesto di far ripartire la tua opzione. Attendi l'SMS di conferma attivazione e utilizzala fino al prossimo rinnovo.",
            renewing: "Non \xe8 possibile procedere con l'operazione richiesta dato che la tua tariffa base si rinnova nelle prossime 24 ore. Attendi l'SMS di rinnovo.",
            credit: "Non \xe8 possibile procedere con il Riparti dato che il credito non \xe8 sufficiente. Ricarica subito e fai ripartire i tuoi giga fino al prossimo rinnovo."
        },
        confirm_renewal: {
            title: "Richiesta di rinnovo",
            description: "Vuoi far ripartire @prodName@ al costo di @renewalCost@€ ?"
        },
        success_renewal: {
            title: "Offerta in rinnovo",
            description: "La richiesta \xe8 andata a buon fine."
        },
        success_renewal_mail_to_send: {
            description: "Attendi l'SMS di conferma entro 48 ore. Inserisci di seguito il tuo indirizzo e-mail per ricevere la conferma del rinnovo:"
        },
        success_renewal_mail_sent: {
            description: "Attendi l'SMS di conferma entro 48 ore. Riceverai un email all'indizzo @emailAddress@"
        }
    },
    customErrors: [
        {
            code: 650,
            imageUrl: "https://myvfapp-aem.vodafone.it/content/dam/myvf/mva10/00_icon_set/red/387_e60000.png",
            message: "Prodotto non presente in catalogo"
        },
        {
            code: 660,
            imageUrl: "https://myvfapp-aem.vodafone.it/content/dam/myvf/mva10/00_icon_set/red/221_e60000.png",
            message: "Il prodotto richiesto risulta gi\xe0 in attivazione"
        },
        {
            code: 670,
            imageUrl: "https://myvfapp-aem.vodafone.it/content/dam/myvf/mva10/00_icon_set/red/387_e60000.png",
            message: "Prodotto non presente in consistenza (offerte attive)"
        },
        {
            code: 680,
            imageUrl: "https://myvfapp-aem.vodafone.it/content/dam/myvf/mva10/00_icon_set/red/387_e60000.png",
            message: "Prodotto non recuperato da AEM"
        },
        {
            code: 690,
            imageUrl: "https://myvfapp-aem.vodafone.it/content/dam/myvf/mva10/00_icon_set/red/221_e60000.png",
            message: "Prodotto in attivazione"
        },
        {
            code: 650,
            imageUrl: "https://myvfapp-aem.vodafone.it/content/dam/myvf/mva10/00_icon_set/red/387_e60000.png",
            message: "Prodotto non pi\xf9 disattivabile"
        },
        {
            code: 392,
            message: "PIN non corretto. Riprova."
        },
        {
            code: 310,
            message: "PIN non corretto. Riprova."
        },
        {
            code: 399,
            message: "E' stato inserito per 3 volte un PIN non corretto. Riprova tra 30 minuti."
        },
        {
            code: 362,
            message: "Il PIN inserito \xe8 scaduto. Richiedine uno nuovo e ricorda di utilizzarlo entro 30 minuti da quando lo ricevi."
        },
        {
            code: 500,
            message: "Servizio momentaneamente non disponibile. Riprova pi\xf9 tardi."
        },
        {
            code: 490,
            message: "Servizio momentaneamente non disponibile. Riprova pi\xf9 tardi."
        }, 
    ]
};
